export default __webpack_public_path__ + "static/media/dashboard-dark.18c1550a.jpg";